<template>
	<span class="content">
		<Username :user="message.from" /> u largua nga chati
		<i class="hostmask"></i>
		<i v-if="message.text" 
			></i
		>
	</span>
</template>

<script>
import ParsedMessage from "../ParsedMessage.vue";
import Username from "../Username.vue";

export default {
	name: "MessageTypeQuit",
	components: {
		ParsedMessage,
		Username,
	},
	props: {
		network: Object,
		message: Object,
	},
};
</script>
